(function () {
  if (customElements.get("details-section")) return;

  class DetailsSection extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.filterButtons = [];
      this.swipers = new Map();
      this.activeTabId = null;
      this.layout = this.dataset.layout || "grid";
      this.perRow = Number(this.dataset.cardsPerRow || 1);
      this.resizeObservers = new Map();
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll(".details__tab"));
      this.filterButtons = Array.from(
        this.querySelectorAll(".heading-group__filter[data-filter-target]")
      );

      if (!this.tabs.length) return;

      const initialId = this.dataset.defaultTab || this.tabs[0].dataset.tabId;

      this.bindFilters();
      this.activateTab(initialId, true);
    }

    disconnectedCallback() {
      this.swipers.forEach((swiper) => {
        if (swiper && typeof swiper.destroy === "function") {
          swiper.destroy(true, true);
        }
      });
      this.swipers.clear();
      this.resizeObservers.forEach((ro) => ro.disconnect());
      this.resizeObservers.clear();
    }

    bindFilters() {
      this.filterButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
          if (btn.classList.contains("active")) return;
          this.setActiveButton(btn);
          this.activateTab(btn.dataset.filterTarget);
        });
      });
    }

    setActiveButton(activeBtn) {
      this.filterButtons.forEach((btn) => btn.classList.remove("active"));
      if (activeBtn) activeBtn.classList.add("active");
    }

    activateTab(tabId, isInitial = false) {
      if (!tabId) return;
      this.activeTabId = tabId;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tabId === tabId;
        tab.classList.toggle("details__tab--active", isActive);

        if (this.layout !== "slider") return;

        if (isActive) {
          this.initSliderForTab(tab);
        } else if (!isInitial) {
          this.destroySliderForTab(tab);
        }
      });
    }

    getCurrentCols() {
      const steps = [
        { bp: 0, cols: 1 },
        { bp: 750, cols: 2 },
        { bp: 1200, cols: 3 },
        { bp: 1536, cols: 4 },
      ];
      const viewportWidth = window.innerWidth;
      let cols = 1;
      steps
        .filter((step) => step.cols <= this.perRow)
        .forEach((step) => {
          if (viewportWidth >= step.bp) cols = step.cols;
        });
      return cols;
    }

    updateOverflow(tab) {
      const wrapper = tab.querySelector(".details__cards-wrapper");
      if (!wrapper) return;
      const visibleSlides = wrapper.querySelectorAll(".details-card").length;
      wrapper.classList.toggle(
        "has-overflow",
        visibleSlides > this.getCurrentCols()
      );
    }

    initSliderForTab(tab) {
      if (this.swipers.has(tab)) return;

      const container = tab.querySelector(".details__cards");
      const wrapper = tab.querySelector(".details__cards-wrapper");
      if (!container || !wrapper || !wrapper.children.length) return;

      // Mobile centers the intermediate slides, first/last stay flush to the edges.
      // Must be switched off explicitly at 750 — breakpoint params merge, they don't reset.
      const swiper = new Swiper(container, {
        slidesPerView: "auto",
        touchEventsTarget: "container",
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        speed: 1000,
        centeredSlides: true,
        centeredSlidesBounds: true,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          750: {
            spaceBetween: 24,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
        },
        on: {
          init: () => this.updateOverflow(tab),
          resize: () => this.updateOverflow(tab),
        },
      });

      this.swipers.set(tab, swiper);

      if (typeof ResizeObserver !== "undefined") {
        const ro = new ResizeObserver(() => {
          if (swiper) swiper.update();
        });
        ro.observe(wrapper);
        this.resizeObservers.set(tab, ro);
      }
    }

    destroySliderForTab(tab) {
      const swiper = this.swipers.get(tab);
      if (swiper && typeof swiper.destroy === "function") {
        swiper.destroy(true, true);
      }
      this.swipers.delete(tab);

      const ro = this.resizeObservers.get(tab);
      if (ro) ro.disconnect();
      this.resizeObservers.delete(tab);
    }
  }

  customElements.define("details-section", DetailsSection);
})();
